import { CommonModule } from '@angular/common';
import { Component, Input} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'so-input',
  templateUrl: './so-input.component.html',
  styleUrls: ['./so-input.component.css'],
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,    
    MatTooltipModule,
    ReactiveFormsModule
  ]
})
export class SoInputComponent {
  @Input() formCtrl: FormControl;
  @Input() placeHolder = "Please enter text.";
  @Input() disableClearBtn = false;
  @Input() errormessage = "Entry is invalid."
  @Input() label = "Label Not set."
  @Input() readOnlyInd = false;
  @Input() toolTip = "";

  clearControl() {
    this.formCtrl.setValue(""); 
  }
 
}
